var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-_x2F_-Endoll"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M309.4,1c8.7,0,15.8,7.1,15.8,15.8l0,0v110.9h47.5c8.7,0,15.8,7.1,15.8,15.8l0,0v95 c0,72.9-54.9,133.1-125.5,141.5c7.1,45.4,46.5,80.2,93.9,80.2h15.8c8.7,0,15.8,7.1,15.8,15.8c0,8.8-7.1,15.8-15.8,15.8h-15.8 c-64.8,0-118.4-48.9-125.8-111.7c-71.6-7.5-127.6-68.2-127.6-141.8l0,0v-95c0-8.8,7.1-15.8,15.8-15.8l0,0h47.5V16.8 c0-8.8,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8l0,0v110.9h95V16.8C293.5,8.1,300.6,1,309.4,1z M356.9,159.4H135.1v79.2 c0,61.1,49.7,110.9,110.9,110.9s110.9-49.7,110.9-110.9l0,0V159.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricPlug);
export default __webpack_public_path__ + "static/media/ElectricPlug.b8947c2e.svg";
export { ForwardRef as ReactComponent };